'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  danger?: boolean;
  variant?: 'danger' | 'warning' | 'default';
}

export default function ConfirmDialog({
  open, title, message, confirmLabel = 'Conferma', cancelLabel = 'Annulla',
  onConfirm, onCancel, danger = false, variant,
}: ConfirmDialogProps) {
  const isDanger = danger || variant === 'danger';
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/70 z-[100] flex items-center justify-center p-4">
      <div className="bg-surface border border-border rounded-2xl w-full max-w-md shadow-2xl">
        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${isDanger ? 'bg-red-500/15' : 'bg-amber-500/15'}`}>
              <Icon
                name={isDanger ? 'ExclamationTriangleIcon' : 'QuestionMarkCircleIcon'}
                size={20}
                className={isDanger ? 'text-red-400' : 'text-amber-400'}
              />
            </div>
            <div>
              <h3 className="text-base font-bold text-white">{title}</h3>
              <p className="text-sm text-secondary-color mt-1 leading-relaxed">{message}</p>
            </div>
          </div>
        </div>
        <div className="flex gap-3 px-6 pb-6">
          <button
            onClick={onCancel}
            className="flex-1 py-2.5 rounded-xl border border-border text-sm font-semibold text-secondary-color hover:text-white hover:bg-surface-elevated transition-all"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className={`flex-1 py-2.5 rounded-xl text-sm font-bold text-white transition-all active:scale-95 ${isDanger ? 'bg-red-500 hover:bg-red-400' : 'bg-sky-500 hover:bg-sky-400'}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
